import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer-grid" }
const _hoisted_4 = { class: "footer-col" }
const _hoisted_5 = { class: "footer-logo" }
const _hoisted_6 = { class: "social-links" }
const _hoisted_7 = {
  href: "https://www.tiktok.com/@okolisy?_r=1&_t=ZS-98snp2dycBr",
  class: "social-link",
  "aria-label": "TikTok"
}
const _hoisted_8 = { class: "footer-col" }
const _hoisted_9 = { class: "footer-links" }
const _hoisted_10 = { class: "footer-col" }
const _hoisted_11 = { class: "footer-links" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { class: "footer-col" }
const _hoisted_17 = { class: "footer-contact" }
const _hoisted_18 = { class: "newsletter-section" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "footer-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_AuthModals = _resolveComponent("AuthModals")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "logo"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("OKOLISY", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "footer-description" }, " La première plateforme gabonaise de vente et d'achat d'articles de mode d'occasion. Rejoignez la communauté et donnez une seconde vie à vos vêtements ! ", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", _hoisted_7, [
              _createVNode(_component_font_awesome_icon, { icon: ['fab', 'tiktok'] })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[12] || (_cache[12] = _createElementVNode("h3", null, "Liens rapides", -1)),
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Accueil", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/a-propos" }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("À propos", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSellClick && _ctx.handleSellClick(...args)), ["prevent"]))
              }, "Vendre un article")
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/comment-ca-marche" }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("Comment ça marche ?", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("li", null, [
              _createElementVNode("a", { href: "#" }, "Foire aux questions")
            ], -1)),
            _cache[11] || (_cache[11] = _createElementVNode("li", null, [
              _createElementVNode("a", { href: "#" }, "Blog")
            ], -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[17] || (_cache[17] = _createElementVNode("h3", null, "Mon compte", -1)),
          _createElementVNode("ul", _hoisted_11, [
            (!_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showLoginModal && _ctx.showLoginModal(...args)), ["prevent"]))
                  }, "Se connecter")
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showRegisterModal && _ctx.showRegisterModal(...args)), ["prevent"]))
                  }, "S'inscrire")
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                  _createVNode(_component_router_link, { to: "/mon-profil" }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode("Mon profil", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                  _createVNode(_component_router_link, { to: "/mes-commandes" }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("Mes commandes", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/conditions-generales" }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode("Conditions générales", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/politique-confidentialite" }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode("Politique de confidentialité", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[21] || (_cache[21] = _createElementVNode("h3", null, "Contact", -1)),
          _createElementVNode("ul", _hoisted_17, [
            _createElementVNode("li", null, [
              _createVNode(_component_font_awesome_icon, { icon: "envelope" }),
              _cache[18] || (_cache[18] = _createElementVNode("a", { href: "mailto:okolisyadmin@gmail.com" }, "okolisyadmin@gmail.com", -1))
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_font_awesome_icon, { icon: "phone" }),
              _cache[19] || (_cache[19] = _createElementVNode("a", { href: "tel:+241076396575" }, "+241 076 39 65 75", -1))
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_font_awesome_icon, { icon: "map-marker-alt" }),
              _cache[20] || (_cache[20] = _createElementVNode("span", null, "Libreville, Gabon", -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[22] || (_cache[22] = _createElementVNode("h3", null, "Restez informé", -1)),
        _cache[23] || (_cache[23] = _createElementVNode("p", null, "Inscrivez-vous à notre newsletter pour recevoir nos offres exclusives", -1)),
        _createElementVNode("form", {
          class: "newsletter-form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.subscribeNewsletter && _ctx.subscribeNewsletter(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "email",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newsletterEmail) = $event)),
            placeholder: "Votre adresse email",
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.newsletterEmail]
          ]),
          _createElementVNode("button", {
            type: "submit",
            disabled: _ctx.newsletterLoading
          }, _toDisplayString(_ctx.newsletterLoading ? '...' : 'S\'abonner'), 9, _hoisted_19)
        ], 32),
        (_ctx.newsletterMessage)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["newsletter-message", _ctx.newsletterMessageType])
            }, _toDisplayString(_ctx.newsletterMessage), 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("p", null, "© " + _toDisplayString(_ctx.currentYear) + " OKOLISY. Tous droits réservés.", 1),
        _cache[24] || (_cache[24] = _createElementVNode("p", { class: "credit" }, [
          _createTextVNode("Développé par "),
          _createElementVNode("a", {
            href: "#",
            target: "_blank"
          }, "Lisy NGUIZI")
        ], -1))
      ])
    ]),
    _createVNode(_component_AuthModals, {
      "show-login-modal": _ctx.showLogin,
      "show-register-modal": _ctx.showRegister,
      onCloseModals: _ctx.closeModals,
      onSwitchToLogin: _ctx.switchToLogin,
      onSwitchToRegister: _ctx.switchToRegister,
      onLoginSuccess: _ctx.handleAuthSuccess,
      onRegisterSuccess: _ctx.handleAuthSuccess
    }, null, 8, ["show-login-modal", "show-register-modal", "onCloseModals", "onSwitchToLogin", "onSwitchToRegister", "onLoginSuccess", "onRegisterSuccess"])
  ]))
}